<template>
  <v-container id="order-list" fluid tag="section">
    <base-material-card outlined icon="mdi-account-outline" class="overflow-visible pb-7">
      <template v-slot:after-heading>
        <div class="font-weight-light card-title mt-2">Lịch sử giao dịch</div>
      </template>
      <validation-observer v-slot="{ handleSubmit }">
        <v-row>
          <v-col cols="12" md="8">
            <v-tabs color="primary" style="background-color: #FFFFFF; padding: 5px 0px 10px 5px;">
              <v-tab v-for="(tab, i) in tabs" :key="i" :to="tab.to">{{ tab.text }}</v-tab>
            </v-tabs>
          </v-col>

          <v-col cols="12" md="4" style="text-align: right;" v-if="checkAuthorization('contact_update')">
            <validation-provider
              v-slot="{ errors }"
              name="Khi thêm, mô tả là"
              :rules="{required: reloadCreateNote, max:255}"
            >
              <v-textarea label="Nhập mô tả" rows="1" v-model="note" :error-messages="errors" />
            </validation-provider>
            <v-btn color="primary" dark @click.prevent="handleSubmit(clickCreateHistoryContact)">
              <v-icon>mdi-plus</v-icon>Thêm
            </v-btn>
          </v-col>
        </v-row>
      </validation-observer>
      <contact-history-table :contactHistorys="contactHistorys" />
      <common-no-result v-if="!loading && totalItem === 0" />
      <v-row>
        <v-col cols="12" sm="6" />
        <v-col cols="12" sm="6">
          <v-pagination
            v-if="totalItem > limit"
            v-model="currentPage"
            :length="getTotalItem(totalItem)"
            class="justify-sm-end"
            prev-icon="mdi-menu-left"
            next-icon="mdi-menu-right"
          />
        </v-col>
      </v-row>
    </base-material-card>
  </v-container>
</template>

<script>
import ContactHistoryTable from './components/ContactHistoryTable';
import { contactDetailTabMenu, contactCreator } from '../../helpers/constants';
import RepositoryFactory from '../../repositories/RepositoryFactory';
const ContactRepository = RepositoryFactory.get('contact');

export default {
  components: {
    ContactHistoryTable
  },
  data() {
    return {
      tabs: [],
      currentPage: 1,
      limit: 10,
      totalItem: 0,
      contactHistorys: [],
      loading: true,
      note: '',
      reloadCreateNote: true,
      dataContact: {}
    };
  },
  async created() {

    this.getContactHistory();
    this.getContactDetail()
    const contactId = _.get(this, '$route.params.id', '');
    this.tabs = contactDetailTabMenu(contactId);
  },
  methods: {
    async clickCreateHistoryContact() {
      if (this.dataContact.mainId) {
        this.$swal({
          title: 'Số điện thoại đã được gộp vào contact ' + this.dataContact.phoneRelated[0] + '.<br>Vui lòng thực hiện các thao tác tại contact chính.',
          confirmButtonText: 'Xem contact chính',
          showCancelButton: true,
          cancelButtonText: 'Quay lại'
        }).then((res) => {
          if (res.value) {
            let routeData = this.$router.resolve({
              name: 'ContactDetail',
              params: {
                id: this.dataContact.mainId || 0
              }
            })
            window.open(routeData.href, '_blank')
          }
        })
      } else {
        if (_.trim(this.note) == '') {
          this.reloadCreateNote = true;
          return;
        }
        const contactId = _.get(this, '$route.params.id', '');
        const dataUpdate = {
          contactId,
          description: _.trim(this.note)
        };
        let loading = this.$loading.show();
        const response = await ContactRepository.createContactHistory(dataUpdate, contactId);
        loading.hide();
        if (response.error) {
          this.errorMessage = _.get(response, 'message', '');
          return;
        }
        this.note = '';
        this.reloadCreateNote = false;
        this.$swal({
          title: 'Thêm lịch sử giao dịch thành công.',
          confirmButtonText: 'Đồng ý'
        }).then(() => {
          this.getContactHistory();
        });
      }
    },
    async getContactHistory() {
      const contactId = _.get(this, '$route.params.id', '');
      const params = {
        limit: this.limit,
        page: this.currentPage - 1
      };
      this.loading = true;
      const loader = this.$loading.show();
      const response = await ContactRepository.getContactHistorys(
        params,
        contactId
      );
      loader.hide();
      this.loading = false;
      if (response.success) {
        this.contactHistorys = _.get(response, 'data', []).map(contact => {
          const contactTemp = contact;
          contactTemp.creatorFullName = _.get(
            contactTemp,
            'creator.fullName',
            null
          );
          if (!contactTemp.creatorFullName) {
            contactTemp.creatorFullName =
              contactCreator[contact.createdBy] || '';
          }
          return contactTemp;
        });
        this.totalItem = response.totalItem;
      } else {
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: _.get(response, 'message', '')
        });
        this.contactHistorys = [];
        this.totalItem = 0;
      }
    },
    async getContactDetail() {
      const loader = this.$loading.show()
      const response = await ContactRepository.detail(this.$route.params.id)
      loader.hide()
      if (response.success) {
        this.dataContact = response.data
      } else {
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: _.get(response, 'message', '')
        });
      }
    }
  },
  watch: {
    currentPage: {
      handler() {
        this.getContactHistory();
      }
    },
    limit: {
      handler() {
        if (this.currentPage === 1) {
          this.getContactHistory();
        } else {
          this.currentPage = 1;
        }
      }
    }
  }
};
</script>
